import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './index.module.scss'
import dayjs from 'dayjs'
export default function CopyRight() {
  const year = dayjs().year()
  const { i18n } = useTranslation()
  const showIcpRecords = () => {
    const domain = window.location.host
    return i18n.language === 'zh-CN' && ['safeheron.vip', 'www.safeheron.vip'].includes(domain)
  }
  return (
    <div className={styles.container}>
      <div>CopyRight © {year}, SAFEHERON PTE. LTD.</div>
      {showIcpRecords() && (
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">
          浙ICP备2021025632号-3
        </a>
      )}
    </div>
  )
}
